import i18n from '@/plugins/i18n';

const errorCodeMessage = new Map([
  ['CD100', i18n.global.t('commonError')],
  ['CD101', i18n.global.t('dashboardNameTakenError')],
  ['CD102', i18n.global.t('invalidDashboardIdError')],
  ['CD103', i18n.global.t('updateTemplateError')],
  ['CD104', i18n.global.t('noDashboardError')],
  ['CD105', i18n.global.t('templateCreationError')],
  ['CD106', i18n.global.t('dashboardDeletionError')],
]);

export default errorCodeMessage;
